import { ApiClient } from '@/libs/device-auth/services/authService';
import { CapacitorApiClient } from './CapacitorApiClient';
import { FetchApiClient } from './FetchApiClient';
import { Capacitor } from '@capacitor/core';

const isNativePlatform = Capacitor.getPlatform() !== 'web';

export const apiClient: ApiClient = isNativePlatform
  ? new CapacitorApiClient()
  : new FetchApiClient();
